import api from '../../utils/api';
import {
    GET_LIST_INSTRUCTION_TEMPLATE,
    GET_SPECIFIC_INSTRUCTION_TEMPLATE,
    UPDATE_SPECIFIC_INSTRUCTION_TEMPLATE,
    CREATE_NEW_INSTRUCTION_TEMPLATE,
    REMOVE_INSTRUCTION_TEMPLATE,
    GET_INSTRUCTION_TEMPLATE_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách Instruction Template theo bộ lọc
 */
export const getListInstructionTemplate = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .get('/instruction-templates', { params: filter })
            .then((res) => {
                dispatch({ type: GET_LIST_INSTRUCTION_TEMPLATE, payload: res.data.data });
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể tải danh sách Instruction Template'
                );
                reject(err);
            });
    });
};

/**
 * Lấy Instruction Template cụ thể theo ID
 */
export const getSpecificInstructionTemplate = (id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/instruction-templates/${id}`)
            .then((res) => {
                dispatch({ type: GET_SPECIFIC_INSTRUCTION_TEMPLATE, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể lấy chi tiết Instruction Template'
                );
                reject(err);
            });
    });
};

/**
 * Lấy danh sách Instruction Template đang hoạt động
 */
export const getInstructionTemplateActive = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .get('/instruction-templates/active', { params: filter })
            .then((res) => {
                dispatch({ type: GET_INSTRUCTION_TEMPLATE_ACTIVE, payload: res.data });
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể tải danh sách đang hoạt động'
                );
                reject(err);
            });
    });
};

/**
 * Tạo mới Instruction Template
 */
export const createInstructionTemplate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .post('/instruction-templates', data)
            .then((res) => {
                dispatch({ type: CREATE_NEW_INSTRUCTION_TEMPLATE, payload: res.data.data });
                NotificationManager.success('Thêm mới Instruction Template thành công!');
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Thêm mới Instruction Template thất bại'
                );
                reject(err);
            });
    });
};

/**
 * Cập nhật Instruction Template
 */
export const updateInstructionTemplate = (id, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .put(`/instruction-templates/${id}`, data)
            .then((res) => {
                dispatch({ type: UPDATE_SPECIFIC_INSTRUCTION_TEMPLATE, payload: res.data.data });
                NotificationManager.success('Cập nhật Instruction Template thành công!');
                resolve(res.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Cập nhật Instruction Template thất bại'
                );
                reject(err);
            });
    });
};

/**
 * Xoá một hoặc nhiều Instruction Template
 */
export const removeInstructionTemplate = (ids) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .delete('/instruction-templates', { data: { ids } })
            .then((res) => {
                dispatch({ type: REMOVE_INSTRUCTION_TEMPLATE, payload: ids });
                NotificationManager.success('Xoá Instruction Template thành công!');
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Xoá Instruction Template thất bại'
                );
                reject(err);
            });
    });
};
